// WightAuditor Mutations

export const updateWeightAuditorList = (state, payload) => {
  state.weightAuditorList = payload
}

export const fetchWeightAuditorInfo = (state, payload) => {
  state.weightAuditorInfo = payload
}
